import React , {useEffect}from "react";
import Divider from "@material-ui/core/Divider";
import { Box, Popover, TextField } from "@material-ui/core";
import styles from "./MonthPlanForm.module.css";
import { Button } from "../../atomicComponents";
import clsx from "clsx";
import { useState } from "react";
import moment from "moment";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";
import { DATE_FORMAT } from "../../constants";

const MonthPlanForm = ({ closeFormPopup, updateMonthPlan ,selectedRow , activeSelectedMonth}) => {
  const [vc, setVC] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [plantName, setPlantName] = useState("");
  const [lineName, setLineName] = useState("");
  const [vcDescription, setVcDesciption] = useState("");
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;
  const selectedMonth = moment(activeSelectedMonth,'MMM-YYYY').format(DATE_FORMAT.YYYY_MM)
  const isLucknowProlifePlant = plant?.label === 'Lucknow-Prolife'
  const parentName = isLucknowProlifePlant ? 'Parent' : 'VC'

  useEffect(() => {
    if (selectedRow) {
      setVC(selectedRow[0].vc || "");
      setQuantity(selectedRow[0].quantity || 0);
      setPlantName(selectedRow[0].plant || "");
      setLineName(selectedRow[0].line || "");
      setVcDesciption(selectedRow[0].description || "");
      
    }
  }, [selectedRow]);
  


  const formSubmit = (event) => {
    if (
      vc &&
      quantity &&
      plant.value &&
      lineName &&
      vcDescription 
    ) {
      const formData = {
        vc: vc,
        quantity:Number(quantity),
        plant: plant.value,
        line: lineName,
        month:selectedMonth,
      };
      updateMonthPlan(formData);  
    }
  };
  return (
    <>
      <Popover
        open={true}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        className={styles.popoverBck}
      >
        <form className={styles.formBox}>
          <div className={styles.formTitleNew}>
            <span className={styles.formTitle}>Month Plan update</span>
            <div className={styles.formlLineDiv} />
          </div>
          <Box
            bgcolor="#dadada3d"
            paddingTop="14px"
            paddingBottom="14px"
            borderRadius="6px"
          >
            <span className={styles.titlespan}>{parentName}</span>
            <span
              style={{ display: "inline", marginLeft: "34%" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="vc"
              value={vc}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Box
            bgcolor="#dadada3d"
            paddingTop="14px"
            paddingBottom="14px"
            borderRadius="6px"
          >
            <span className={styles.titlespan}>{parentName} Description</span>
            <span
              style={{ display: "inline", marginLeft: "13%" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="vc"
              value={vcDescription}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Divider className={styles.partitionLine} />
          <Box bgcolor="#dadada3d" paddingTop="17px">
            <span className={styles.titlespan}>Monthly Quantity  </span>
            <span
              style={{ display: "inline", marginLeft: "6%" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="quantity"
              value={quantity}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[0-9]*$/.test(value)) {
                  setQuantity(value);
                }
              }}
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="17px">
            <span className={styles.titlespan}>Plant</span>
            <span
              style={{ display: "inline", marginLeft: "29%" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="plant"
              value={plantName}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="12px">
            <span className={styles.titlespan}>Line</span>
            <span
              style={{ display: "inline", marginLeft: "31%" }}
              className={styles.formSubTitle}
            >
              <TextField
              name="linename"
              value={lineName}
              disabled
              className={clsx(styles.textField, styles.sel1)}
              InputProps={{
                disableUnderline: true,
                className: styles.select,
              }}
            />
            </span>
          </Box>
          <div style={{ float: "right" }}>
            <Button
              variant="primary"
              className={clsx(styles.button, styles.confirmButton)}
              type="button"
              onClick={formSubmit}
            >
              CONFIRM
            </Button>
            <Button
              className={clsx(styles.button, styles.cancelButton)}
              onClick={closeFormPopup}
            >
              CANCEL
            </Button>
          </div>
        </form>
      </Popover>
    </>
  );
};

export default MonthPlanForm;
